import { GenericForm } from '@neo/blocks/forms/generic-form'
import { useIntegrationRollout } from 'v2/shared/hooks/use-integration-rollout'
import type { RExternalAppDetails } from 'v2/types/api/settings'
import {
  buildIntegrationConnectionFormConfig,
  type IntegrationFormValues,
} from './integration-connection-form.config'

export type { IntegrationFormValues } from './integration-connection-form.config'

interface IntegrationConnectionFormProps {
  app: RExternalAppDetails
  onSubmit: (values: IntegrationFormValues) => void
}

export const IntegrationConnectionForm = ({ app, onSubmit }: IntegrationConnectionFormProps) => {
  const { useAciIntegrations } = useIntegrationRollout()
  const config = buildIntegrationConnectionFormConfig(app, useAciIntegrations)

  return (
    <GenericForm<IntegrationFormValues>
      id="integration-external-app-form"
      key={app.id}
      className="p-0.5"
      fields={config.fields}
      onSubmit={onSubmit}
      formValidators={{ onSubmit: config.schema }}
      defaultValues={config.defaults}
      includeSubmitButton={false}
    />
  )
}
